var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-with-description-box"},[_c('p',[_vm._v(_vm._s(_vm.description))]),_c('button',{class:_vm.buttonClass,on:{"click":function($event){return _vm.movePage()}}},[_vm._v(_vm._s(_vm.buttonName))])])}
var staticRenderFns = []

export { render, staticRenderFns }